import { ORDER_STATUS_DATA, ORDER_STATUS_ERROR_DATA, ORDER_STATUS_HIDE_ERROR_DATA, ORDER_STATUS_START_LOADER, ORDER_STATUS_STOP_LOADER, } from "../interface/iOrderStatus";
const initialState = {
    data: { data: { list: [] } },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const orderStatus = (state = initialState, action) => {
    switch (action.type) {
        case ORDER_STATUS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case ORDER_STATUS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ORDER_STATUS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case ORDER_STATUS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ORDER_STATUS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default orderStatus;
